// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-widget__tabs .ant-tabs-left-bar{max-width:calc(25% - 20px)}.content-widget__tabs .ant-tabs-nav .ant-tabs-tab{white-space:normal}@media (max-width:991px){.content-widget__tabs .ant-tabs-nav .ant-tabs-tab{max-width:calc(100vw - 84px);text-align:center}}", ""]);
// Exports
module.exports = exports;
